import { Navigate, Route, Routes } from 'react-router-dom'
import { OwnerPage } from './features/owner/OwnerPage'
import { SharePage } from './features/share/SharePage'

export function App() {
  return (
    <Routes>
      {/* Recipient view: /p/<token>. Owner view: /owner (app-hosted WebView with an
          injected Firebase token). */}
      <Route path='/p/:token' element={<SharePage />} />
      <Route path='/owner' element={<OwnerPage />} />
      <Route path='*' element={<Navigate to='/p/missing' replace />} />
    </Routes>
  )
}
